export default "__VITE_ASSET__BHRvhjT8__"